module.exports = __webpack_public_path__ + "media/images/landkit/avatars/avatar-3-8020d4e17339fe13944c3a1be71509fd.jpg";